import handleAuthError from './authMiddleware'
import { showModalMessage } from '../layout'
import {
  createUserCartRequest,
  addItemToUserCartRequest,
  addItemToGuestCartRequest,
  editUserCartEntryRequest,
  editGuestCartEntryRequest,
  createGuestCartRequest,
  getGuestCartRequest
} from '../../utils/user'
import { reportModalPageView } from '../../analytics/userAnalytics'
import { logError } from '../../utils/errors'

const addItemToCartRequestAction = () => ({ type: 'addItemToCartRequest' })
const addItemToCartSuccessAction = response => {
  reportModalPageView({
    title: 'Modal: Item added to cart',
    page: `${window.location.pathname}/item-added-to-cart${window.location
      .search}`
  })
  return {
    type: 'addItemToCartSuccess',
    payload: response
  }
}

const getGuestUserCartRequestAction = () => ({
  type: 'getGuestUserCartRequest'
})
const getGuestUserCartFailureAction = () => ({
  type: 'getGuestUserCartFailure'
})

export const getGuestUserCart = () => {
  return async dispatch => {
    try {
      dispatch(getGuestUserCartRequestAction())
      const response = await getGuestCartRequest()
      const cartData = response.data === '' ? null : response.data
      return dispatch(getGuestUserCartSuccessAction(cartData))
    } catch (err) {
      logError(err)
      dispatch(getGuestUserCartFailureAction())
    }
  }
}

const getGuestUserCartSuccessAction = cart => ({
  type: 'getGuestUserCartSuccess',
  payload: cart
})

const createUserCartRequestAction = () => ({
  type: 'createUserCartRequest'
})
const createUserCartSuccessAction = cart => ({
  type: 'createUserCartSuccess',
  payload: cart
})
const createUserCartFailureAction = () => ({
  type: 'createUserCartFailure'
})

export const addItemToCart = data => {
  return async (dispatch, getState) => {
    const { user: { token, cart } } = getState()
    // add to signed in user cart
    if (token) {
      // create cart is missing
      if (!cart) {
        try {
          dispatch(createUserCartRequestAction())
          const newCart = await createUserCartRequest(token)
          dispatch(createUserCartSuccessAction(newCart))
        } catch (err) {
          if (err.statusCode === 401) {
            return dispatch(handleAuthError(addItemToCart(data)))
          } else {
            logError(err)
            dispatch(createUserCartFailureAction())
            return dispatch(
              showModalMessage({ message: 'Creating user cart failed' })
            )
          }
        }
      }

      dispatch(addItemToCartRequestAction())
      try {
        const response = await addItemToUserCartRequest(token, data)
        return dispatch(addItemToCartSuccessAction(response))
      } catch (err) {
        if (err.statusCode === 401) {
          return dispatch(handleAuthError(addItemToCart(data)))
        } else {
          logError(err)
          return dispatch(
            showModalMessage({ message: 'Adding item to cart failed' })
          )
        }
      }
      // add to guest user cart
    } else {
      dispatch(addItemToCartRequestAction())
      if (!cart) {
        const newCart = await createGuestCartRequest()
        await dispatch(getGuestUserCartSuccessAction(newCart))
      }

      try {
        const response = await addItemToGuestCartRequest(data)
        return dispatch(addItemToCartSuccessAction(response))
      } catch (err) {
        logError(err)
        return dispatch(
          showModalMessage({ message: 'Adding item to cart failed' })
        )
      }
    }
  }
}

const editCartEntryRequestAction = () => ({ type: 'editCartEntryRequest' })
const editCartEntrySuccessAction = response => ({
  type: 'editCartEntrySuccess',
  payload: response
})

export const editCartEntry = (entryID, data) => {
  return async (dispatch, getState) => {
    const { user: { token } } = getState()
    // edit to signed in user cart
    if (token) {
      dispatch(editCartEntryRequestAction())
      try {
        const response = await editUserCartEntryRequest(token, entryID, data)
        return dispatch(editCartEntrySuccessAction(response))
      } catch (err) {
        if (err.statusCode === 401) {
          return dispatch(handleAuthError(editCartEntry(entryID, data)))
        } else {
          logError(err)
          return dispatch(
            showModalMessage({
              message: 'Cart update failed. Please try again.'
            })
          )
        }
      }
      // edit to guest user cart
    } else {
      dispatch(editCartEntryRequestAction())
      try {
        const response = await editGuestCartEntryRequest(entryID, data)
        return dispatch(editCartEntrySuccessAction(response))
      } catch (err) {
        logError(err)
        return dispatch(
          showModalMessage({ message: 'Cart update failed. Please try again.' })
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./common/actions/user/cart.js